import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';

import RSButton, { ButtonProps as RSButtonProps } from 'reactstrap/lib/Button';
import { primaryFontFamily } from '../../styles/fonts';

function applyColors({ theme, color }: RSButtonProps & { theme: Theme }) {
  if (color === 'link') {
    return css`
      background-color: transparent;
      color: ${theme.default.colors.n5};
      fill: ${theme.default.colors.n5};

      &:hover {
        color: ${theme.default.colors.n4};
        fill: ${theme.default.colors.n4};
      }

      &:active {
        color: ${theme.default.colors.n3};
        fill: ${theme.default.colors.n3};
      }

      &:disabled,
      &[disabled] {
        color: ${theme.default.colors.n2};
        fill: ${theme.default.colors.n2};
        cursor: default;
      }
    `;
  } else if (color === 'externalLink') {
    return css`
      background-color: ${theme.default.primaryColor};
      color: white;
      fill: white;
    `;
  }

  return css`
    background-color: ${theme.default.colors.n5};
    color: ${theme.default.colors.n0};

    &:hover {
      background-color: ${theme.default.colors.n4};
    }

    &:active {
      background-color: ${theme.default.colors.n3};
    }

    &:disabled,
    &[disabled] {
      background-color: ${theme.default.colors.n2};
      cursor: default;
    }
  `;
}

export const StyledButton = styled(RSButton)<RSButtonProps>`
  padding: ${({ size }) => {
    if (size === 'small') {
      return '8px 16px';
    }

    return '14px 20px';
  }};
  border: 0;
  border-radius: 4px;

  ${primaryFontFamily}
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  cursor: pointer;
  transition: background-color 350ms ease;

  ${applyColors}
`;
